import { EMAIL_BUILDER_CANVAS_VERTICAL_RAIL_GAP_PX } from '../shell/canvas/emailBuilderCanvasRailLayoutConstants';

export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_TOP_OFFSET_PX = 4;
export const EMAIL_BUILDER_VERTICAL_ACTION_RAIL_ANCHOR_SELECTOR = '.email-rail-anchor';

export function emailBuilderVerticalActionRailLeft(
  anchorLeft: number,
  railWidth: number,
): number {
  return anchorLeft - railWidth - EMAIL_BUILDER_CANVAS_VERTICAL_RAIL_GAP_PX;
}

export function emailBuilderCanvasMainCanvasBounds(
  canvas: HTMLElement,
  canvasRect: DOMRectReadOnly,
): { left: number; right: number } {
  const left = canvasRect.left + canvas.clientLeft;
  return {
    left,
    right: left + canvas.clientWidth,
  };
}

export function emailBuilderVerticalActionRailAnchorElement(
  frame: HTMLElement,
): HTMLElement | null {
  const anchor = frame.querySelector(EMAIL_BUILDER_VERTICAL_ACTION_RAIL_ANCHOR_SELECTOR);
  return anchor instanceof HTMLElement ? anchor : null;
}

export function emailBuilderVerticalActionRailAnchorLeft(
  frame: HTMLElement,
  frameRect: DOMRectReadOnly,
  useRowGroupAnchor: boolean,
): number {
  if (!useRowGroupAnchor) {
    return frameRect.left;
  }
  const anchor = emailBuilderVerticalActionRailAnchorElement(frame);
  if (anchor) {
    return anchor.getBoundingClientRect().left;
  }
  return frameRect.left;
}

export function clampEmailBuilderVerticalActionRailLeft(
  anchorLeft: number,
  canvas: HTMLElement,
  canvasRect: DOMRectReadOnly,
  railWidth: number,
): number {
  const { left: canvasLeft, right: canvasRight } = emailBuilderCanvasMainCanvasBounds(
    canvas,
    canvasRect,
  );
  const edgeGap = EMAIL_BUILDER_CANVAS_VERTICAL_RAIL_GAP_PX;
  const canvasMin = canvasLeft + edgeGap;
  const canvasMax = canvasRight - edgeGap;
  const idealLeft = emailBuilderVerticalActionRailLeft(anchorLeft, railWidth);

  const railLeft = Math.max(idealLeft, canvasMin);
  return Math.min(railLeft, canvasMax - railWidth);
}
